import React from 'react';

const Arrow = () => {
  /* eslint-disable */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
      <g fill="none" fillRule="evenodd" stroke="gray" strokeLinecap="round" strokeLinejoin="round">
        <path d="M7.323 4H1.165M4.577 6.886l3.346-2.86-3.346-2.86" />
      </g>
    </svg>
  );
};

export default Arrow;



// WEBPACK FOOTER //
// ./src/components/Icons/Arrow.js